module.exports = __webpack_public_path__ + "static/media/feature-11.6a006227.jpg";